var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: "19px",
    height: "26px",
    viewBox: "0 0 19 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.250000, 0.750000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75,7.5 C17.2687831,7.5 18.5,8.73121694 18.5,10.25 L18.5,21.75 C18.5,23.2687831 17.2687831,24.5 15.75,24.5 L2.75,24.5 C1.23121694,24.5 0,23.2687831 0,21.75 L0,10.25 C0,8.73121694 1.23121694,7.5 2.75,7.5 L6.25,7.5 L6.25,9 L2.75,9 C2.05964406,9 1.5,9.55964406 1.5,10.25 L1.5,21.75 C1.5,22.4403559 2.05964406,23 2.75,23 L15.75,23 C16.4403559,23 17,22.4403559 17,21.75 L17,10.25 C17,9.55964406 16.4403559,9 15.75,9 L12.25,9 L12.25,7.5 L15.75,7.5 Z",
    id: "Combined-Shape",
    fill: "#1A89FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71966991,0.219669914 C9.01256313,-0.0732233047 9.48743687,-0.0732233047 9.78033009,0.219669914 L9.78033009,0.219669914 L13.7803301,4.21966991 C14.0732233,4.51256313 14.0732233,4.98743687 13.7803301,5.28033009 C13.4874369,5.5732233 13.0125631,5.5732233 12.7196699,5.28033009 L12.7196699,5.28033009 L10,2.561 L10,15.75 C10,16.1296958 9.71784612,16.443491 9.35177056,16.4931534 L9.25,16.5 C8.83578644,16.5 8.5,16.1642136 8.5,15.75 L8.5,15.75 L8.5,2.559 L5.78033009,5.28033009 C5.51406352,5.54659665 5.09739984,5.5708027 4.80378835,5.35294824 L4.71966991,5.28033009 C4.4267767,4.98743687 4.4267767,4.51256313 4.71966991,4.21966991 L4.71966991,4.21966991 Z",
    id: "Combined-Shape",
    fill: "#007AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.9ef7e10b44755a56330979e162e1e597.svg";
export { ForwardRef as ReactComponent };